<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #sidenav
    [mode]="isMobileView ? 'over' : 'side'"
    [opened]="!isMobileView || isMobileMenuOpen"
    [disableClose]="!isMobileView"
    class="sidenav">
    <div class="sidenav-header">
      <ng-container *ngIf="isBrandingLoading; else resolvedDesktopLogo">
        <div class="logo-loading-placeholder" aria-label="Loading organization branding">
          <mat-spinner diameter="28"></mat-spinner>
        </div>
      </ng-container>
      <ng-template #resolvedDesktopLogo>
        <img
          *ngIf="settings?.logoUrl; else defaultLogo"
          [src]="settings?.logoUrl"
          [alt]="settings?.logoAlt || 'Company Logo'"
          class="logo">
        <ng-template #defaultLogo>
          <img src="assets/tbds-common-logo.png" alt="The Big Data Showroom" class="logo">
        </ng-template>
      </ng-template>
    </div>
    <mat-nav-list>
      <a mat-list-item class="sidebar-nav-item" *ngIf="isPlatformContext" (click)="navigateTo('/platform-admin')">
        <mat-icon>admin_panel_settings</mat-icon>
        <span class="nav-link-text">Platform Admin</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="isPlatformContext" (click)="navigateTo('/platform-admin/stats')">
        <mat-icon>query_stats</mat-icon>
        <span class="nav-link-text">Stats</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="isPlatformContext" (click)="navigateTo('/platform-admin/feature-flags')">
        <mat-icon>toggle_on</mat-icon>
        <span class="nav-link-text">Feature Flags</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="isAdmin && !isPlatformContext" (click)="navigateTo('/admin/new-request')">
        <mat-icon>search</mat-icon>
        <span class="nav-link-text">Search</span>
      </a>
      <a
        mat-list-item
        class="sidebar-nav-item"
        *ngIf="isAdmin && !isPlatformContext && (user$ | async)?.features?.['trust_search']"
        (click)="navigateTo('/admin/trust-request')">
        <mat-icon>account_balance</mat-icon>
        <span class="nav-link-text">Search Trust</span>
      </a>
      <a
        mat-list-item
        class="sidebar-nav-item"
        *ngIf="isAdmin && !isPlatformContext && (user$ | async)?.features?.['digital_onboarding']"
        (click)="navigateTo('/admin/digital-onboarding')">
        <mat-icon>verified_user</mat-icon>
        <span class="nav-link-text">Digital Onboarding</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="isAdmin && !isPlatformContext" (click)="navigateTo('/admin/users')">
        <mat-icon>people</mat-icon>
        <span class="nav-link-text">Manage Users</span>
      </a>
      <a
        mat-list-item
        class="sidebar-nav-item"
        *ngIf="isAdmin && !isPlatformContext && (user$ | async)?.features?.['campaigns']"
        (click)="navigateTo('/admin/campaigns')">
        <mat-icon>campaign</mat-icon>
        <span class="nav-link-text">Campaigns</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="!isAdmin && !isPlatformContext" (click)="navigateTo('/user/data-request')">
        <mat-icon>search</mat-icon>
        <span class="nav-link-text">Search</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="!isAdmin && !isPlatformContext && (user$ | async)?.features?.['trust_search']" (click)="navigateTo('/user/trust-request')">
        <mat-icon>account_balance</mat-icon>
        <span class="nav-link-text">Search Trust</span>
      </a>
      <a
        mat-list-item
        class="sidebar-nav-item"
        *ngIf="!isAdmin && !isPlatformContext && (user$ | async)?.features?.['digital_onboarding']"
        (click)="navigateTo('/user/digital-onboarding')">
        <mat-icon>verified_user</mat-icon>
        <span class="nav-link-text">Digital Onboarding</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="isAdmin && !isPlatformContext" (click)="navigateTo('/admin/address-book')">
        <mat-icon>contacts</mat-icon>
        <span class="nav-link-text">Address Book</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="!isAdmin && !isPlatformContext" (click)="navigateTo('/user/address-book')">
        <mat-icon>contacts</mat-icon>
        <span class="nav-link-text">Address Book</span>
      </a>
      <a mat-list-item class="sidebar-nav-item" *ngIf="!isPlatformContext" (click)="navigateTo('/my-account')">
        <mat-icon>manage_accounts</mat-icon>
        <span class="nav-link-text">My Account</span>
      </a>
      <a
        mat-list-item
        class="sidebar-nav-item"
        *ngIf="!isPlatformContext && (user$ | async)?.features?.['street_search']"
        (click)="navigateTo('/admin/street-search')">
        <mat-icon>map</mat-icon>
        <span class="nav-link-text">Street Search</span>
      </a>
    </mat-nav-list>
    <div class="org-selector-wrap" *ngIf="showOrgSelector">
      <mat-form-field appearance="outline" class="org-selector-field">
        <mat-label>Organization</mat-label>
        <mat-select
          [value]="selectedOrgId"
          [disabled]="switchingOrg"
          (selectionChange)="onOrganizationChanged($event.value)">
          <mat-option *ngFor="let org of orgOptions" [value]="org.orgId">
            {{ org.displayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="sidenav-footer">
      <div class="user-info" *ngIf="user$ | async as user">
        <div class="email-with-role">
          <span class="email-text">{{ user.email }}</span>
          <mat-icon 
            class="role-icon" 
            [class.admin-icon]="user.role === 'admin'"
            [class.user-icon]="user.role === 'user'"
            [matTooltip]="user.isPlatformAdmin ? 'Platform Admin' : (user.role === 'admin' ? 'Administrator' : 'User')"
            matTooltipPosition="above">
            {{ user.isPlatformAdmin ? 'shield' : (user.role === 'admin' ? 'admin_panel_settings' : 'person') }}
          </mat-icon>
        </div>
        <div class="mode-toggle-wrap" *ngIf="canToggleMode">
          <button
            mat-stroked-button
            type="button"
            class="mode-switch-button"
            (click)="onModeChanged(appMode === 'platform' ? 'org' : 'platform')">
            {{ appMode === 'platform' ? 'Switch to Organization' : 'Switch to Platform Admin' }}
          </button>
        </div>
        <div
          class="user-credits"
          *ngIf="!isPlatformContext && userCredits !== null"
          [class.user-credits--clickable]="userCredits.creditsRemaining <= 0"
          [attr.role]="userCredits.creditsRemaining <= 0 ? 'link' : null"
          [attr.tabindex]="userCredits.creditsRemaining <= 0 ? 0 : null"
          [attr.title]="userCredits.creditsRemaining <= 0 ? 'Top up credits in Account Info' : null"
          (click)="onCreditsClick($event)"
          (keydown.enter)="onCreditsClick($event)"
          (keydown.space)="onCreditsClick($event)">
          <mat-icon class="credits-icon" [class.credits-empty]="userCredits.creditsRemaining <= 0">account_balance_wallet</mat-icon>
          <div class="credits-copy">
            <div class="credits-primary">
              <span class="credits-text" [class.credits-empty]="userCredits.creditsRemaining <= 0">
                {{ userCredits.creditsRemaining }} credits remaining
              </span>
              <mat-icon
                class="credits-info-icon"
                [matTooltip]="creditsBreakdownTooltip"
                matTooltipPosition="above"
                aria-label="Credits breakdown details">
                info
              </mat-icon>
            </div>
            <div
              class="credits-meta"
              *ngIf="userCredits.planDisplayName || userCredits.billingTermLabel">
              <span class="credits-plan" *ngIf="userCredits.planDisplayName">{{ userCredits.planDisplayName }}</span>
              <span
                class="credits-meta-sep"
                *ngIf="userCredits.planDisplayName && userCredits.billingTermLabel"
                aria-hidden="true">·</span>
              <span class="credits-term" *ngIf="userCredits.billingTermLabel">{{ userCredits.billingTermLabel }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-actions">
        <button
          mat-button
          class="footer-action-button theme-toggle-button"
          type="button"
          aria-label="Toggle theme"
          (click)="toggleTheme()">
          <mat-icon>wb_sunny</mat-icon>
        </button>
        <button mat-button class="footer-action-button logout-button" (click)="logout()">
          <mat-icon>logout</mat-icon>
          Logout
        </button>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="masquerade-banner" *ngIf="(masqueradeState$ | async) as masquerade">
      <div class="masquerade-banner-copy">
        <mat-icon>visibility</mat-icon>
        <span>Masquerading as {{ masquerade.displayName }}</span>
      </div>
      <button mat-stroked-button color="warn" type="button" (click)="stopMasquerade()">
        Stop
      </button>
    </div>
    <div class="mobile-topbar" *ngIf="isMobileView">
      <button mat-icon-button type="button" aria-label="Open navigation menu" (click)="toggleMobileMenu()">
        <mat-icon>menu</mat-icon>
      </button>
      <div class="mobile-logo-wrap">
        <ng-container *ngIf="isBrandingLoading; else resolvedMobileLogo">
          <div class="logo-loading-placeholder mobile" aria-label="Loading organization branding">
            <mat-spinner diameter="22"></mat-spinner>
          </div>
        </ng-container>
        <ng-template #resolvedMobileLogo>
          <img
            *ngIf="settings?.logoUrl; else defaultMobileLogo"
            [src]="settings?.logoUrl"
            [alt]="settings?.logoAlt || 'Company Logo'"
            class="mobile-logo">
          <ng-template #defaultMobileLogo>
            <img src="assets/tbds-common-logo.png" alt="The Big Data Showroom" class="mobile-logo">
          </ng-template>
        </ng-template>
      </div>
      <button
        mat-icon-button
        type="button"
        class="mobile-theme-toggle"
        [attr.aria-label]="(isDarkMode$ | async) ? 'Enable light mode' : 'Enable dark mode'"
        (click)="toggleTheme()">
        <mat-icon>{{ (isDarkMode$ | async) ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>
    </div>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>

